import { UserEntity } from "@/models/userEntity";
import { MrfiktivUpdateUserDtoGen } from "@/services/mrfiktiv/v1/data-contracts";

export class UpdateUserDtoFactory {
  user: MrfiktivUpdateUserDtoGen = {
    firstName: "",
    lastName: "",
    contact: {
      phone: "",
      email: ""
    },
    address: {
      street: "",
      city: "",
      zip: "",
      state: ""
    },
    company: "",
    taxnumber: ""
  };

  createFromUserEntity(user: UserEntity): MrfiktivUpdateUserDtoGen {
    this.user.firstName = user.firstName;
    this.user.lastName = user.lastName;
    this.user.contact.email = user?.contact?.email || "";
    this.user.contact.phone = user?.contact?.phone || "";
    this.user.address.street = user?.address?.street || "";
    this.user.address.zip = user?.address?.zip || "";
    this.user.address.city = user?.address?.city || "";
    this.user.address.state = user?.address?.state || "";
    this.user.company = user?.company || "";
    this.user.taxnumber = user?.taxnumber || "";

    return this.user;
  }
}
